export const mfaMethods = {
  EMAIL: "email",
} as const;
